





























import { Vue, Component, Prop } from 'vue-property-decorator';
import Icon from '@/components/Icon.vue';
import { IField } from '@/fields/types/field';
import { EFieldSource } from '@/fields/types/enums/field-source';
import { defaultDropdownOption } from '@signing-page/fields/constants/field-placeholders';

@Component({
  components: {
    Icon,
  },
})
export default class DropdownField extends Vue {
  @Prop() field: IField;
  @Prop() disabled: boolean;
  @Prop() completed: boolean;

  dropdownOpen: boolean = false;

  get value(): string {
    if (this.field.source === EFieldSource.Sender) {
      return this.field.value || this.field.label;
    }
    return this.field.value || this.field.label || this.defaultOption;
  }

  get showRequired(): boolean {
    if (this.completed || this.disabled) {
      return false;
    }
    return this.field.isRequired;
  }

  get showArrow(): boolean {
    return !this.disabled;
  }

  get options(): string[] {
    if (this.isDefaultValue(this.value) || this.field.isRequired) {
      return this.field.options;
    }
    return [this.defaultOption, ...this.field.options];
  }

  get defaultOption(): string {
    return this.$t(defaultDropdownOption).toString();
  }

  isDefaultValue(value: string): boolean {
    return value === this.defaultOption;
  }

  handleSelection(value: string) {
    if (!this.disabled) {
      this.$emit('update', value);
      this.closeDropdown();
    }
  }

  toggleDropdown() {
    this.dropdownOpen = !this.dropdownOpen;
    this.$emit('toggleDropdown', this.dropdownOpen);
  }

  closeDropdown() {
    this.dropdownOpen = false;
    this.$emit('toggleDropdown', this.dropdownOpen);
  }
}
